import report from './report';

export default (F) => ({
  ...report(F),
});
